import * as Yup from 'yup';

export const validationSchema = Yup.object().shape({
    name: Yup.string()
        .required('Name is required')
        .max(100, 'Name must not exceed 100 characters'),
    organizationId: Yup.string()
        .required('8x8 Organization ID is required')
        .max(50, 'Organization ID must not exceed 50 characters'),
    apiKey: Yup.string()
        .required('API Key is required')
        .max(255, 'API Key must not exceed 255 characters'),
    keyExpiry: Yup.string(),
});

export const SERVICE_PROVIDERS_COLUMNS = [
    {
        field: 'name',
        headerName: 'Name',
        sortable: true,
        resizable: true,
        flex: 1,
        minWidth: 150,
    },
    {
        field: 'organizationId',
        headerName: '8x8 Organization ID',
        sortable: true,
        resizable: true,
        flex: 1,
        minWidth: 180,
    },
    {
        field: 'apiKey',
        headerName: 'API Key',
        sortable: false,
        resizable: true,
        flex: 1.2,
        minWidth: 200,
        cellStyle: { fontFamily: 'monospace', fontSize: '12px' },
    },
    {
        field: 'keyExpiry',
        headerName: 'Key Expires (UTC)',
        sortable: true,
        resizable: true,
        flex: 1,
        minWidth: 180,
    },
    {
        maxWidth: 70,
        headerName: 'Actions',
        filter: false,
        suppressMovable: true,
        sortable: false,
        lockPosition: 'right',
        cellStyle: () => ({
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
        }),
        cellRenderer: 'actionCellRenderer',
    },
];

export const FORM_VALIDATION = {
    name: {
        label: 'Name',
        required: true,
        maxLength: 100,
        placeholder: 'e.g. BT, AT&T, SoftBank',
    },
    organizationId: {
        label: '8x8 Organization ID',
        required: true,
        maxLength: 50,
        placeholder: 'e.g. 8x8-ORG-100001',
    },
    apiKey: {
        label: 'API Key',
        required: true,
        maxLength: 255,
        placeholder: 'Enter API key',
    },
    keyExpiry: {
        label: 'API Key Expiry (UTC)',
        required: false,
    },
};

export const WALKTHROUGH_IDS = {
    addBtn: '/globaladmin/service-providers/button/add',
    editBtn: '/globaladmin/service-providers/button/edit',
    deleteBtn: '/globaladmin/service-providers/button/delete',
    table: '/globaladmin/service-providers/table',
};
